import {ChangeDetectorRef, Component, HostBinding, inject, input, OnInit} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {StoryblokDirective} from '@core/directives/storyblok.directive';
import {DynamicModule} from 'ng-dynamic-component';

import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {FormValidationClassDirective} from '@core/directives/form-validation-class.directive';
import {CartService} from '@core/services/cart.service';
import {LoadingComponent} from '@layout/components/general/loading/loading.component';
import {GoogleService} from '@core/services/google.service';
import {StoreConfigService} from '@core/services/store-config.service';


@Component({
  selector: 'app-buy-giftcard',
  templateUrl: './storyblok-buy-giftcard.component.html',
  styleUrls: ['./storyblok-buy-giftcard.component.scss'],
  imports: [StoryblokDirective, DynamicModule, ReactiveFormsModule, StoryblokDirective, StoryblokDirective, FormValidationClassDirective, LoadingComponent]
})
export class StoryblokBuyGiftcardComponent implements OnInit {
  private storyblokStylingService = inject(StoryblokStylingService);
  private cartService = inject(CartService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private googleService = inject(GoogleService);
  private storeConfigService = inject(StoreConfigService);

  readonly _editable = input<any>();
  readonly general_styling = input<any>();
  readonly productId = input<number>(20000);
  @HostBinding('class') class: any;

  loading = false;
  giftcardAdded = false;
  currencyCode = this.storeConfigService.currencyCode;

  formGroup: FormGroup<{
    amount: FormControl<string | null>;
  }>;

  constructor() {
    this.formGroup = new FormGroup({
      amount: new FormControl('', {
        validators: [
          Validators.pattern('^[0-9]*$'),
          Validators.min(50),
          Validators.max(10000),
          Validators.required
        ]
      })
    });
  }

  ngOnInit() {
    this.class = this.storyblokStylingService.getClassList(this.general_styling(), {
      desktop: {
        'margin-bottom': '.5rem',
        'margin-top': '.5rem'
      }
    }, {'col-': 12});
  }

  formSubmit() {
    if (!this.formGroup.value.amount) {
      return;
    }
    const giftcardAmount = +this.formGroup.value.amount;
    if (this.formGroup.valid && giftcardAmount > 0) {
      this.loading = true;
      this.giftcardAdded = false;
      this.cartService.addToCart('', this.productId(), 1, 'giftcard-page', giftcardAmount * 100).then(() => {
        this.formGroup.reset({amount: ''});
        this.giftcardAdded = true;
        this.googleService.addGiftcardToCartEvent(giftcardAmount);
      }).finally(() => {
        this.loading = false;
        this.changeDetectorRef.detectChanges();
      }).catch((reason) => {
        throw reason;
      });
    }
  }

}
